var MDB = window.MDB || {};
MDB.Mangl = MDB.Mangl || {};
MDB.Mangl.Annotations = MDB.Mangl.Annotations || {};

(function () {
    $.extend(MDB.Mangl.Annotations,
        {
            _apiBaseUrl: '/api/mangl/Annotations/',
            _getUrlForVerb: function(verb) {
                return MDB.Mangl.Annotations._apiBaseUrl + verb;
            },

            boot: function (model) {
                var grid = $('#annotations-grid')
                    , divisionDropdown = $('#division-dropdown').detach()
                    , builder = MDB.KendoConfigBuilder
                    , divisionNameMapping = {};

                model.divisions.forEach(function (d) {
                    divisionNameMapping[d.value] = d.text; 
                });

                var ds = new kendo.data.DataSource({
                    transport: {
                        read: function (opts) {
                            builder.dataSourceTransportFunction(MDB.Mangl.Annotations._getUrlForVerb('get'), 'GET', opts) 
                        },
                        create: function (opts) {
                            builder.dataSourceTransportFunction(MDB.Mangl.Annotations._getUrlForVerb('post'), 'POST', opts) 
                        },
                        update: function (opts) {
                            builder.dataSourceTransportFunction(MDB.Mangl.Annotations._getUrlForVerb('put'), 'PUT', opts) 
                        }
                    },
                    schema: {
                        model: {
                            id: 'Id',
                            fields: {
                                Id: { editable: false },
                                CreatedByName: { editable: false },
                                DivisionId: { editable: true, required: true},
                                Value: { editable: true, required: true },
                                Created: {type: 'date', editable: false },
                                Date: { type: 'date', editable: true,  required: true },
                                Remarks: { editable: true }
                            }
                        }
                    },
                    error: function (e) {
                        this.cancelChanges();
                        alert(builder.getWebApiErrorsMessage(e));
                    },
                    pageSize: 20,
                    sort: {
                        field: 'Date',
                        dir: 'desc'
                    }
                });

                var gridConf = {
                    dataSource: ds,
                    columns: [{
                        field: 'Created',
                        title: 'Aangemaakt op',
                        format: '{0:dd-MM-yyyy}',
                        filterable: builder.gridDateTimeFilter('{0:dd-MM-yyyy}', true)
                    }, {
                        field: 'CreatedByName',
                        title: 'Aangemaakt door'
                    }, {
                        field: 'DivisionId',
                        title: 'Divisie',
                        template: function (model) {
                            return divisionNameMapping[model.DivisionId]; 
                        },
                        editor: function(container, opts) {
                            builder.gridDropdownEditor(container, opts.field, divisionDropdown);
                        }
                    },{
                        field: 'Value',
                        title: 'Annotatie'
                    }, {
                        field: 'Date',
                        title: 'Datum',
                        format: '{0:dd-MM-yyyy}',
                        filterable: builder.gridDateTimeFilter('{0:dd-MM-yyyy}', true)
                    }, {
                        field: 'Remarks',
                        title: 'Opmerkingen'
                    }],
                    messages: {
                        commands: builder.commandLabels(),
                        noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                    },
                    navigatable: true,
                    sortable: true,
                    filterable: builder.gridGlobalFilterableSettings(),
                    resizable: true,
                    pageable: builder.gridPageableSettings()
                };

                if (model.canEditAnnotations) {
                    gridConf.editable = {
                        mode: 'inline',
                        confirmation: false
                    };

                    gridConf.toolbar = ['create'];
                    gridConf.columns.push(builder.gridCommandColumn([ 'edit' ]));
                }

                grid.kendoGrid(gridConf);
            }
        });
}());